export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0;
};
//# sourceMappingURL=isEmptyObject.js.map